exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/amort-table/amort-table.component.css
// module id = ../../../../../src/app/amort-table/amort-table.component.css
// module chunks = main